$(document).ready(function() {
	$('#sticky-sidebar').theiaStickySidebar({
      // Settings
      additionalMarginTop: 120,
      containerSelector: '#sticky-sidebar-container',
      sidebarBehavior: 'stick-to-top'
    });

    $('#sticky-sidebar a').click(function(e){
    	e.preventDefault();
    	var scrollTarget = $(this).attr('rel');
    	$('#sticky-sidebar a').removeClass('active');
    	$(this).addClass('active');
    	$('#sticky-sidebar-content div').removeClass('active');
    	$(scrollTarget).addClass('active');
    	$(window).scrollTo(scrollTarget, 500, {
    		easing: 'linear',
    		offset: {
    			top: -136
    		}
    	});
    });
});
